var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c(
        "router-link",
        {
          attrs: {
            "active-class": "",
            to: { name: "bookings.show", params: { id: this.booking.id } },
          },
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.bookingName))]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { class: _vm.profileTalentBookingListItemColumns }, [
                  _c("p", [
                    _c("i", { staticClass: "fa fa-map-marker fa-fw" }),
                    _vm._v(" " + _vm._s(_vm.bookingStateOrOnline)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.profileTalentBookingListItemColumns }, [
                  _vm.bookingAppearanceInPerson || _vm.bookingAppearanceOffer
                    ? _c("p", [
                        _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("nullable")(
                                _vm._f("dateTimezone")(
                                  _vm.booking.tz_date,
                                  _vm.booking.timezone,
                                  _vm.$user.date_format_preference
                                )
                              )
                            )
                        ),
                      ])
                    : _c("p", [
                        _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                        _vm._v(" –"),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.profileTalentBookingListItemColumns }, [
                  _c("p", [
                    _vm.bookingIsContextuallyCancelled
                      ? _c("span", { staticClass: "label label-danger" }, [
                          _vm._v("Cancelled"),
                        ])
                      : _vm.bookingIsScheduled
                      ? _c("span", { staticClass: "label label-success" }, [
                          _vm._v("Scheduled"),
                        ])
                      : _vm.bookingIsOnHold
                      ? _c("span", { staticClass: "label label-info" }, [
                          _vm._v("On Hold"),
                        ])
                      : _vm.bookingIsBooked
                      ? _c("span", { staticClass: "label label-success" }, [
                          _vm._v("Booked"),
                        ])
                      : _vm.bookingIsCompleted
                      ? _c("span", { staticClass: "label label-info" }, [
                          _vm._v("Completed"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$userIsAdmin && _vm.bookingIsNotPublic
                      ? _c("span", { staticClass: "label-hidden" }, [
                          _vm._v("Hidden"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bookingBookedDepositUnpaid
                      ? _c("span", { staticClass: "label label-danger" }, [
                          _vm._v("Deposit Unpaid"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bookingBookedDepositSent
                      ? _c("span", { staticClass: "label label-danger" }, [
                          _vm._v("Deposit Sent"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm.$userIsAdmin ||
                (_vm.$vlastMode && _vm.$isCricketAus && _vm.$userIsManager)
                  ? _c(
                      "div",
                      { class: _vm.profileTalentBookingListItemColumns },
                      [
                        _c("p", [
                          _vm._v("Booking ID: " + _vm._s(this.booking.id)),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.userCanSeeBudget && !_vm.bookingAppearanceOffer
            ? _c(
                "span",
                { staticClass: "price" },
                [
                  _vm.booking.local_currency
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("nullable")(
                                _vm._f("currency")(
                                  _vm.booking
                                    .local_currency_budget_per_star_as_user_rate,
                                  _vm.booking.local_currency
                                )
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("nullable")(
                                _vm._f("currency")(
                                  _vm.booking.budget_per_star_as_user_rate,
                                  _vm.booking.currency
                                )
                              )
                            ) +
                            "\n      "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }